import request from "@/utils/request";

export default function agentGetWeChatUserInfo(weChatUserId) {
    return request({
        url: `/user/weChartUser/agentGetWeChatUserInfo?weChatUserId=${weChatUserId}`,
        method: 'post',
    })
}
